import { OnCloseDialogTitle } from '../../../atoms/OnCloseDialogTitle';
import { ClosableDialog } from '../../ClosableDialog';
import React from 'react';
import PropTypes from 'prop-types';
import DialogContent from '@mui/material/DialogContent';
import { FormContainer } from 'react-hook-form-mui';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Unstable_Grid2';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Snackbar from '@mui/material/Snackbar';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


export const GenericModalForm = ({
  open,
  onClose,
  defaultValues,
  editTitle,
  addTitle,
  onSubmit,
  onSubmitText,
  onSubmitTitle,
  children,
  onNewSnackText,
  onEditSnackText
}) => {
  const isNew = !defaultValues?.id;
  const [internalError, setInternalError] = React.useState(null);
  const [internalLoading, setInternalLoading] = React.useState(false);
  const [showSaveSnack, setShowSaveSnack] = React.useState(false);
  return (<>
    <Snackbar
      open={!!showSaveSnack}
      autoHideDuration={10000}
      onClose={() => setShowSaveSnack(false)}
    >
      <Alert
        action={<IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={() => setShowSaveSnack(false)}
        >
          <CloseIcon fontSize="small" />
        </IconButton>}
        onClose={() => setShowSaveSnack(false)}
        severity="success" sx={{ width: '100%' }}
      >
        {isNew ? onNewSnackText : onEditSnackText}
      </Alert>
    </Snackbar>

    <ClosableDialog
      open={open}
      onClose={onClose}
      BackdropProps={{ style: { backgroundColor: 'white' } }}
      fullScreen
      TransitionComponent={Transition}
    >
      <OnCloseDialogTitle onClose={onClose}>{isNew ? addTitle : editTitle}</OnCloseDialogTitle>
      <FormContainer
        defaultValues={defaultValues}
        onSuccess={(formValues) => {
          setInternalLoading(true);
          setInternalError(false);
          onSubmit({ formValues })?.then(() => {
            setShowSaveSnack(true);
            setInternalLoading(false);
            onClose();
          })?.catch(err => {
            setInternalError(err);
            setInternalLoading(false);
          });
        }}
      >
        <DialogContent dividers={true} style={{
          height: '100%'
        }}>
          <Stack spacing={3}>
            {internalError ? (<Alert severity={'error'}>
              <AlertTitle>
                Submission failed.
              </AlertTitle>
              {(internalError instanceof String || typeof internalError === 'string') ? internalError : ''} If the
              problem persists,
              please contact support.</Alert>) : null}
            <Grid container spacing={3}>
              {children ? children({
                loading: internalLoading
              }) : null}
            </Grid>
          </Stack>
          <div></div>
        </DialogContent>
        <DialogActions>
          <Button disabled={internalLoading} color="tertiary" variant="contained"
            onClick={onClose}>Cancel</Button>
          <Button disabled={internalLoading} color="primary" variant="contained" type={'submit'}
            title={onSubmitTitle}>{onSubmitText}</Button>
        </DialogActions>
      </FormContainer>
    </ClosableDialog>

  </>);
};

GenericModalForm.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  defaultValues: PropTypes.shape({}),
  editTitle: PropTypes.string.isRequired,
  addTitle: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSubmitText: PropTypes.string,
  onSubmitTitle: PropTypes.string,
  onNewSnackText: PropTypes.string,
  onEditSnackText: PropTypes.string,
  children: PropTypes.func.isRequired
};

GenericModalForm.defaultProps = {
  onClose: () => {
  },
  defaultValues: {},
  onSubmitText: 'Save',
  onSubmitTitle: 'Save this information',
  onSubmit: () => Promise.resolve(true)
};

export default GenericModalForm;
